var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSave({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.5,
    height: 19.5,
    viewBox: "0 0 19.5 19.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-save",
    "data-name": "Icon feather-save",
    transform: "translate(-3.75 -3.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10617",
    "data-name": "Path 10617",
    d: "M20.5,22.5H6.5a2,2,0,0,1-2-2V6.5a2,2,0,0,1,2-2h11l5,5v11A2,2,0,0,1,20.5,22.5Z",
    fill: "none",
    stroke: "#33af89",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10618",
    "data-name": "Path 10618",
    d: "M20.5,27.5v-8h-10v8",
    transform: "translate(-2 -5)",
    fill: "none",
    stroke: "#33af89",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10619",
    "data-name": "Path 10619",
    d: "M10.5,4.5v5h8",
    transform: "translate(-2)",
    fill: "none",
    stroke: "#33af89",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/save.c82dc49b820efa76ee4663220fb9f2b3.svg";
export { ForwardRef as ReactComponent };